import { useEffect, useState } from 'react';

const useRouteDrawer = (params) => {
  const isOpen = !!params?.userSubscriptionId;
  const [activeParams, setActiveParams] = useState(isOpen ? params : null);

  useEffect(() => {
    if (isOpen) setActiveParams(params);
  }, [params?.userId, params?.userSubscriptionId]);

  const getAfterOpenChange = () => (open) => {
    if (!open) setActiveParams(null);
  };

  return { isOpen, activeParams, getAfterOpenChange };
};

export default useRouteDrawer;
